module.exports = __webpack_public_path__ + "static/media/Openbank.645985c3.png";